import React from 'react';
import './AuthorsModal.css';
import weeiw from '../../assets/weeia.jpeg';
import innowacja from '../../assets/innowacja.png';

interface AuthorsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const AuthorsModal = ({ isOpen, onClose }: AuthorsModalProps) => {
  if (!isOpen) return null;

  return (
    <div className="authors-modal-overlay">
      <div className="authors-modal-content">
        <button className="authors-modal-close" onClick={onClose}>✖</button>
        <h3>O aplikacji</h3>
        <p>
          Aplikacja powstała w ramach Projektu Innowacja realizowanego na Wydziale Elektrotechniki, 
          Elektroniki, Informatyki i Automatyki pod opieką Joanny Jojczyk i Matuesza Starzaka.
        </p>
        <div className="authors-logos">
          <a href="https://weeia.p.lodz.pl/" target="_blank" rel="noopener noreferrer">
            <img src={weeiw} alt="Logo WEEIA" />
          </a>
          <img src={innowacja} alt="Logo Projektu Innowacja" />
        </div>
        <div className="authors-list">
          Autorzy: Adrian Antczak, Igor Białas, Theo De Schaeck, Hubert Gajdowski, 
          Mateusz Gwóźdź, Jakub Jaworski, Kacper Jarosik, Timothy Kalejaiye, 
          Jan Koślin, Jakub Kozłowski, Bartosz Matusiak, Piotr Nakonowski, 
          Adam Plewa, Aleksandra Pindral, Maksymilian Posieł, Tomasz Wasilewski
        </div>
      </div>
    </div>
  );
};

export default AuthorsModal; 